import { render } from "./AppointmentView.vue?vue&type=template&id=a90b34d8&scoped=true"
import script from "./AppointmentView.vue?vue&type=script&lang=js"
export * from "./AppointmentView.vue?vue&type=script&lang=js"

import "./AppointmentView.vue?vue&type=style&index=0&id=a90b34d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a90b34d8"]])

export default __exports__